module.exports = __webpack_public_path__ + "product-pure-powder-capsule-05.jpg?746df189581ac193b2a16ef5f1e5e23c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-05.jpg
// module id = 87
// module chunks = 0